<template>
  <div class="tab-form">
    <div v-for="(tabItem, index) in tabList" :key="index" class="tab-button">
      <tab-item
        :tabItem="tabItem"
        :index="index"
        :selectedTabIndex="selectedTabIndex"
        :changeSelectTabIndex="changeSelectTabIndex"
      />
    </div>
  </div>
</template>

<script>
/**
 * タブ一覧を描画するコンポーネント
 * @Parent O.SelectedVessel
 * @parent O.VesselEquipmentBaseStations
 * @props tabList: Array タブ一覧情報の配列
 * @props changeSelectedTabIndex: Function タブインデックス情報を更新する関数、A.TabItem内で発火させる。
 * @props selectedTabIndex: Number 選択されているタブのインデックス番号
 */
import TabItem from "@/components/atoms/TabItem";
export default {
  name: "M.TabForm",
  components: {
    TabItem,
  },
  props: {
    tabList: {
      type: Array,
    },
    changeSelectedTabIndex: {
      type: Function,
      required: true,
    },
    selectedTabIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    // タブの切り替わりを知らせる
    changeSelectTabIndex(index) {
      this.changeSelectedTabIndex(index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/aisea/variables";

.tab-form {
  height: 40px;
  display: flex;
  background: $aisea-blue-gray;
  .tab-button {
    display: flex;
    width: 133px;
  }
}
</style>
